import Medusa from '@medusajs/js-sdk';

const MEDUSA_BACKEND_URL =
  process.env.NEXT_PUBLIC_MEDUSA_BACKEND_URL || 'http://localhost:9000';

export const SALES_CHANNEL_ID =
  process.env.NEXT_PUBLIC_MEDUSA_SALES_CHANNEL_ID;

export const REGION_ID = process.env.NEXT_PUBLIC_MEDUSA_REGION_ID;

export const DEFAULT_COUNTRY =
  process.env.NEXT_PUBLIC_DEFAULT_COUNTRY || 'de';

export const sdk = new Medusa({
  baseUrl: MEDUSA_BACKEND_URL,
  publishableKey: process.env.NEXT_PUBLIC_MEDUSA_PUBLISHABLE_KEY,
  debug: false,
});

const MEDIA_HOST = (process.env.NEXT_PUBLIC_MEDIA_HOST || '').replace(/\/$/, '');
const LEGACY_BUCKET_HOSTS = [
  'bucket-production-d393.up.railway.app',
];

/**
 * Resolve the public URL for a Medusa product image. The Medusa backend stores
 * uploaded images in MinIO with a fully-qualified URL, but for legacy /static
 * paths we prepend the backend URL. When `NEXT_PUBLIC_MEDIA_HOST` is set, any
 * URLs pointing at the legacy Railway internal bucket hostname are rewritten
 * to the public media domain so Next.js' image optimizer can resolve them.
 */
export function imageUrl(image) {
  if (!image) return '/images/default-image.jpeg';
  const url = typeof image === 'string' ? image : image.url;
  if (!url) return '/images/default-image.jpeg';

  let resolved = /^https?:\/\//i.test(url)
    ? url
    : `${MEDUSA_BACKEND_URL}${url.startsWith('/') ? '' : '/'}${url}`;

  if (MEDIA_HOST) {
    for (const host of LEGACY_BUCKET_HOSTS) {
      const escaped = host.replace(/\./g, '\\.');
      const re = new RegExp(`https?:\\/\\/${escaped}`, 'i');
      if (re.test(resolved)) {
        resolved = resolved.replace(re, MEDIA_HOST);
        break;
      }
    }
  }

  return resolved;
}
